module.exports = __webpack_public_path__ + "static/img/16.b3f8595.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/16.jpg
// module id = KGDV
// module chunks = 1